import React, { useState } from 'react';
import { colors } from '@styleseat/brand';
import { NotificationsAlertTriangleIcon } from '../../../ui/Icons/NotificationsAlertTriangleIcon';
import NcdCancellationPolicyAcceptanceModalContainer from '../../newClientDelivery/NcdCancellationPolicyAcceptanceModal';

import NotificationBanner from '../NotificationBanner';

export type NotificationProps = {
  type: 'ncd_cancellation_policy';
  uuid: string;
  persistent: boolean;
  providerId: number;
  creation_time: string;
};

type NcdCancellationPolicyNotificationProps = {
  providerId: number;
  notification: NotificationProps;
  onCTAClick: () => void;
  onAccept: () => void;
};

const NcdCancellationPolicyNotification: React.FC<NcdCancellationPolicyNotificationProps> = ({
  providerId,
  notification,
  onCTAClick,
  onAccept,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleOnClick = () => {
    setShowModal(true);
    onCTAClick();
  };

  const handleOnAccept = () => {
    setShowModal(false);
    onAccept();
  };

  return (
    <React.Fragment>
      <NotificationBanner
        icon={NotificationsAlertTriangleIcon}
        iconColor={colors.red}
        notification={notification}
        buttonProps={{
          text: 'Accept New Rules & Restrictions',
          size: 'small',
          appearance: 'text-light',
          onClick: handleOnClick,
        }}
        highlightedText="Review StyleSeat rules & restrictions on new clients we send you."
      />
      <NcdCancellationPolicyAcceptanceModalContainer
        visible={showModal}
        providerId={providerId}
        onAccept={handleOnAccept}
      />
    </React.Fragment>
  );
};

export default NcdCancellationPolicyNotification;
